export var ChainId_Internal;
(function (ChainId_Internal) {
    ChainId_Internal[ChainId_Internal["ETHEREUM"] = 1] = "ETHEREUM";
    ChainId_Internal[ChainId_Internal["SEPOLIA"] = 11155111] = "SEPOLIA";
    ChainId_Internal[ChainId_Internal["ZK_EVM"] = 388] = "ZK_EVM";
    ChainId_Internal[ChainId_Internal["ZK_EVM_TEST"] = 240] = "ZK_EVM_TEST";
    ChainId_Internal[ChainId_Internal["CRONOS_EVM_MAINNET"] = 25] = "CRONOS_EVM_MAINNET";
    ChainId_Internal[ChainId_Internal["CRONOS_EVM_TESTNET"] = 338] = "CRONOS_EVM_TESTNET";
})(ChainId_Internal || (ChainId_Internal = {}));
